/*  Copyright 2018, 2019 Sebastian Spautz

    This file is part of "AiS Online Forms".

    "AiS Online Forms" is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    any later version.
    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.
    You should have received a copy of the GNU General Public License
    along with this program.  If not, see http://www.gnu.org/licenses/.
*/

/** Main modul for the AIS Online Forms App
  * @module acesinspace.main
*/
import FormControls           from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/components/formControls.mjs'
import CollaborationControls  from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/components/collaborationControls.mjs'
//import {}                     from '../../../node_modules/@sebastiansit/webcomponents/select-image/src/select-image.js'
import * as formoperator      from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/main.mjs'
import initPWA                from './pwa.js'

document.addEventListener('DOMContentLoaded', function (/* event */) {
  console.debug('DOMContentLoaded (in Main)')
  // Register custom elements
  window.customElements.define('sit-formcontrols', FormControls)
  window.customElements.define('sit-collaborationcontrols', CollaborationControls)

  initPWA((window.sitforms?.basepath || './') + 'serviceworker.js')

  formoperator.loadInitial()
    .then(() => {
      // TODO initial stuff after loading sheet data 
    })
    .then(() => { // switch view mode if query parameter is set
      const viewModeParam = new URL(window.location.href).searchParams.get('viewmode')
      if (viewModeParam) {
        formoperator.switchViewMode(document.getElementsByTagName('form')[0], viewModeParam)
        document.body.classList.add(viewModeParam)
      }
    })

  initCollaborationButton()
})

window.addEventListener('load', () => {
  console.debug('Loaded (in Main)')
  const collabButton = document.getElementById('button-collaboration-open')
  const collabDialog = document.querySelector('dialog')

  if (collabButton) {
    /* Handle network status changes */
    window.addEventListener('offline', () => {
      collabButton.disabled = true
      collabDialog.close()
    })
    window.addEventListener('online', () => {
      collabButton.disabled = false
    })
  }
})

// Init Collaboration Function and DOM
function initCollaborationButton() {
  // Collaboration Dialog
  const collaborationDialog = document.querySelector('dialog')

  if (collaborationDialog) {
    // Dialog öffnen
    const controlOpenDialog = document.getElementById('button-collaboration-open')
    const onOpenDialog = (/* event */) => {
      collaborationDialog.showModal()
    }
    controlOpenDialog.addEventListener('pointerup', onOpenDialog)
    controlOpenDialog.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        onOpenDialog(event)
      }
    })

    // Dialog schließen
    const controlCloseDialog = document.getElementById('control_closeDialog')
    const onCloseDialog = (/* event */) => {
      collaborationDialog.close()
    }
    controlCloseDialog.addEventListener('pointerup', onCloseDialog)
    controlCloseDialog.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        onCloseDialog(event)
      }
    })
  }
}